import React, { createContext } from "react";
import ProjectFilePlanReducerAction from "./project-file-plan-reducer-action";
import ProjectFileReducerAction from "./project-file-reducer-action";

import PlanFileData from "@/pages/takeoff/context/project-measure/models/plan-file-data";
import BaseFileData from "@/pages/takeoff/context/project-organisation/models/base-file-data";
import ProjectOrganisationBuilding from "@/pages/takeoff/context/project-organisation/models/project-organisation-building";
import ProjectOrganisationStorey from "@/pages/takeoff/context/project-organisation/models/project-organisation-storey";

export interface ProjectFilePlanContextProps {
    isOverlayActive: boolean;
    setIsOverlayActive: (active: boolean) => void;

    planFileDataLeft: PlanFileData;
    fileDataRight: BaseFileData;

    urlFileLeft: string;
    urlFileRight: string | undefined;

    building: ProjectOrganisationBuilding | undefined;
    storey: ProjectOrganisationStorey | undefined;

    fileLeft: BaseFileData | undefined;
    fileRight: BaseFileData | undefined;

    isDirty: boolean;
    isSaving: boolean;

    setFileIdRight: (id: string | undefined) => void;

    isDrawingLeft: boolean;
    setIsDrawingLeft: (open: boolean) => void;
    isDrawingRight: boolean;
    setIsDrawingRight: (open: boolean) => void;

    dispatchLeft: React.Dispatch<ProjectFilePlanReducerAction>;
    dispatchRight: React.Dispatch<ProjectFileReducerAction>;

    saveCurrentFileData: () => Promise<boolean>;
}

export const ProjectFilePlanContext = createContext<ProjectFilePlanContextProps | undefined>(undefined);